import * as React from 'react';
import { useEditorInput_unstable } from './useEditorInput';
import { renderEditorInput_unstable } from './renderEditorInput';
import { useEditorInputStyles_unstable } from './useEditorInputStyles.styles';
import type { EditorInputProps } from './EditorInput.types';
import type { ForwardRefComponent } from '@fluentui/react-components';
import { useEditorInputContextValues } from './useEditorInputContextValues';

// EditorInput component - TODO: add more docs
export const EditorInput: ForwardRefComponent<EditorInputProps> = React.forwardRef((props, ref) => {
  const state = useEditorInput_unstable(props, ref);
  const contextValues = useEditorInputContextValues(state);

  useEditorInputStyles_unstable(state);
  return renderEditorInput_unstable(state, contextValues);
});

EditorInput.displayName = 'EditorInput';
